export default "__VITE_ASSET__dbc3a5f2__"